import React from 'react'

function ImmoListe() {
  return (
    <div>ImmoListe</div>
  )
}

export default ImmoListe